var __default__ = {root:'m_7485cace'};
export default __default__;